import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, Type } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { BodyKnowledgeDetailModule } from '../../molecules/body-knowledge-detail/body-knowledge-detail.module';
import { ButtonModule } from '../../atoms/button/button.module';
import { CommonModule } from '@angular/common';
import { CreateRequestModalComponent } from './create-request-modal.component';
import { CreateTagModule } from './../../molecules/create-tag/create-tag.module';
import { DatepickerModule } from '../../atoms/datepicker/datepicker.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderCardModule } from '../header-card/header-card.module';
import { KnowledgeAttachmentViewModule } from '../../molecules/knowledge-attachment-view/knowledge-attachment-view.module';
import { KnowledgeBodyTitleModule } from '../../molecules/knowledge-body-title/knowledge-body-title.module';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { TextModule } from '../../atoms/text/text.module';
import { TextareaModule } from '../../atoms/textarea/textarea.module';

const components: Type<any>[] = [CreateRequestModalComponent];

@NgModule({
  imports: [
    CommonModule,
    NzDropDownModule,
    TextModule,
    TextareaModule,
    HeaderCardModule,
    KnowledgeAttachmentViewModule,
    KnowledgeBodyTitleModule,
    BodyKnowledgeDetailModule,
    ButtonModule,
    DatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    // TODO: why not load image
    AngularSvgIconModule,
    CreateTagModule
  ],
  declarations: [components],
  exports: [components],
})
export class CreateRequestModalModule { }
